export const APP_NAME = 'Isempower'
